"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const AddParticipantsPanel_1 = __importDefault(require("./AddParticipantsPanel"));
const ParticipantsPanel_1 = __importDefault(require("./ParticipantsPanel"));
const panels_1 = require("../../domain/model/panels");
exports.default = RightPanel;
function RightPanel(props) {
    switch (props.type) {
        case panels_1.RightPanelType.AddParticipants:
            return react_1.default.createElement(AddParticipantsPanel_1.default, null);
        case panels_1.RightPanelType.Participants:
            return react_1.default.createElement(ParticipantsPanel_1.default, null);
        default:
            return react_1.default.createElement(react_1.default.Fragment, null);
    }
}
